import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import TimelineIcon from '@material-ui/icons/Timeline';

export const rootRouteRef = createRouteRef();

const roadmapPage = PageBlueprint.make({
  params: {
    path: '/roadmap',
    title: 'Roadmap',
    icon: <TimelineIcon fontSize="inherit" />,
    routeRef: rootRouteRef,
    loader: async () => {
      const { RoadmapPage } = await import('./pages/RoadmapPage');
      return <RoadmapPage />;
    },
  },
});

export const roadmapPlugin = createFrontendPlugin({
  pluginId: 'roadmap',
  extensions: [roadmapPage],
});
